import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FilterChipsComponent } from "./filter-chips.component";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import {MatIconModule} from '@angular/material/icon';
import { FilterTagsChipsComponent } from "./filter-tags-chips/filter-tags-chips.component";

@NgModule({
  declarations: [FilterChipsComponent,FilterTagsChipsComponent],
  imports: [CommonModule, MatChipsModule,MatIconModule],
  exports:[FilterChipsComponent,FilterTagsChipsComponent]
})
export class FilterChipsModule {}
